/* The USP line as a marquee, on a phone.

   The theme's own ticker was the obvious thing to lean on, and it did not
   run here: it only animates when it measures its content as wider than the
   bar, and inside the toolbar it does not. Rather than keep guessing at
   somebody else's measuring, this builds the marquee itself.

   Two copies of the line sit side by side and the pair slides by half its
   width, so the loop is seamless. It is set up below 750px and taken down
   again above it, leaving the theme's markup exactly as it was. */
(function () {
  var QUERY = '(max-width: 749px)';
  var query = window.matchMedia(QUERY);

  function frames() {
    return document.querySelectorAll('.toolbar .toolbar__text__frame');
  }

  function build(frame) {
    if (frame.dataset.marquee === 'on') return;

    var source = frame.querySelector('[data-ticker-text]');
    if (!source) return;

    if (!frame.dataset.original) frame.dataset.original = frame.innerHTML;

    var lane = document.createElement('div');
    lane.className = 'bakkeleg-marquee';

    /* The theme's ticker may have left copies of its own behind. They go, so
       the two halves of the lane are identical and the loop meets itself. */
    var clean = source.cloneNode(true);
    var strays = clean.querySelectorAll('[data-clone]');
    for (var i = 0; i < strays.length; i++) strays[i].remove();

    var first = clean.cloneNode(true);
    var second = clean.cloneNode(true);
    second.setAttribute('aria-hidden', 'true');
    lane.appendChild(first);
    lane.appendChild(second);

    frame.innerHTML = '';
    frame.appendChild(lane);
    frame.dataset.marquee = 'on';

    /* The distance is one half of the lane, measured rather than assumed, and
       the time follows the distance so the speed is the same whatever the
       text says. A jump at the end of a loop is the distance and the content
       disagreeing. */
    var half = first.getBoundingClientRect().width;
    if (half > 0) {
      lane.style.setProperty('--marquee-distance', half + 'px');
      lane.style.setProperty('--marquee-time', (half / 60).toFixed(2) + 's');
    }
  }

  function tearDown(frame) {
    if (frame.dataset.marquee !== 'on') return;
    if (frame.dataset.original) frame.innerHTML = frame.dataset.original;
    frame.dataset.marquee = 'off';
  }

  function sync() {
    var list = frames();
    for (var i = 0; i < list.length; i++) {
      if (query.matches) {
        build(list[i]);
      } else {
        tearDown(list[i]);
      }
    }
  }

  sync();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  }

  window.addEventListener('load', sync);

  if (query.addEventListener) {
    query.addEventListener('change', sync);
  } else if (query.addListener) {
    query.addListener(sync);
  }

  document.addEventListener('shopify:section:load', sync);
})();
